<div class="content">
  <label class="content__input">
    <i #icon class="content__input-icon icon icon-search-outline"></i>

    <input
      #addressInput
      type="text"
      class="content__input-control"
      placeholder="Search your address here"
      [attr.data-size]="size()"
      [style.padding-left.px]="icon.offsetWidth + 32"
      (ngModelChange)="onAddressChange($event)"
      [(ngModel)]="addressControl"
    />
  </label>

  @if (isShippingAvailable()) {
    @if (suggestions().length > 0) {
      <ul class="content__suggestions suggestions">
        @for (address of suggestions(); track address.Id) {
          <li class="suggestions__item suggestion">
            <button
              class="suggestion__button"
              (click)="onAddressSelect(address)"
            >
              <span class="suggestion__button_label">{{ address.Text }}</span>
            </button>
          </li>
        }
      </ul>
    }
  } @else {
    <div class="content__no-delivery no-delivery">
      <img
        src="./assets/images/sad-face.png"
        loading="lazy"
        alt="sad face"
        class="no-delivery__image"
      />
      <span class="no-delivery__label">
        <span class="no-delivery__label-text">
          Unfortunately we don’t deliver to your address,
        </span>
        <button
          type="button"
          class="no-delivery__label-button"
          (click)="onTryDifferentAddressClick()"
        >
          try a different address
        </button>
      </span>
    </div>
  }
</div>
